/* Temporary ad injection */

Drupal.behaviors.contentAdBehaviour = {
  attach: function (context, settings) {
    // Your code here, with 'context' to target specific parts of the DOM
    let article_content_text = once(
      "articleContent",
      ".node-article-content-wrapper .node-article-description > p",
      context
    );
    let s1_ad_script_vilnius =
      '<div class="desktop-ad-s1 text-align-center my-2"><script data-adfscript="adx.adform.net/adx/?mid=304433"></script></div>';

    let s1_ad_script_klaipeda =
      '<div class="desktop-ad-s1 text-align-center my-2"><script data-adfscript="adx.adform.net/adx/?mid=322258"></script></div>';
      
    let s1_ad_script_kaunas =
      '<div class="desktop-ad-s1 text-align-center my-2"><script data-adfscript="adx.adform.net/adx/?mid=322256"></script></div>';

    /* let s1_ad_script = document.createElement("script");
      s1_ad_script.type = "text/javascript";
      s1_ad_script.setAttribute(
        "data-adfscript",
        "adx.adform.net/adx/?mid=" + 322258
      ); */
    let hostname = window.location.hostname;

    article_content_text.forEach((item, index) => {
      if (index === 0) {
        if (hostname.startsWith('diena.')) {
          item.insertAdjacentHTML("beforebegin", s1_ad_script_vilnius);
        } else if(hostname.startsWith('klaipeda.')) {
          item.insertAdjacentHTML("beforebegin", s1_ad_script_klaipeda);
        } else if(hostname.startsWith('kauno.')) {
          item.insertAdjacentHTML("beforebegin", s1_ad_script_kaunas);
        }
      }
    });
  },
};
